export default __webpack_public_path__ + "static/media/next_arrow.3f4a6f06.svg";